// eslint-disable-next-line strict
export default null;



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/helpers/null.js
// module id = 71
// module chunks = 1